import { FormGroup, FormParagraph } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

type YesNoReadOnlyFormElementProps = {
    label: string;
    value: boolean;
};

export function YesNoReadOnlyFormElement({ label, value }: YesNoReadOnlyFormElementProps) {
    const translate = getSelectedLanguage();

    return (
        <FormGroup label={label}>
            <FormParagraph>{value ? translate.common.yes : translate.common.no}</FormParagraph>
        </FormGroup>
    );
}
